module.exports = _vendor;